/* Extracted from sections/ts-home-v2.liquid */
function initTenderSoundsHomeFinder() {
    document.querySelectorAll('.ts-vehicle-finder').forEach(function (form) {
      if (form.dataset.tsHomeFinderReady === 'true') return;
      form.dataset.tsHomeFinderReady = 'true';
      form.addEventListener('submit', function (event) {
        var input = form.querySelector('input[name="q"]');
        var query = input ? input.value.trim() : '';
        if (!query) {
          event.preventDefault();
          if (input) input.focus();
          return;
        }
        event.preventDefault();
        window.location.href = '/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(query);
      });
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTenderSoundsHomeFinder, { once: true });
} else {
  initTenderSoundsHomeFinder();
}
